import { BaseInput } from '@app/components/common/inputs/BaseInput/BaseInput';
import { Row, Col, Form, Input, Space } from 'antd';

type UserInfoProps = {
  mode: string | 'view' | 'edit';
};
export const UserInfo: React.FC<UserInfoProps> = (props) => {
  const readOnly = props.mode == 'view';
  const requiredMark = !readOnly;
  return (
    <>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="first_name" label="First Name" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="last_name" label="Last Name" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="username" label="Username" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="email" label="Email" rules={[{ required: requiredMark, type: 'email' }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="contact_no" label="Contact No" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="dob" label="Date of Birth" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} type="date" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="address" label="Address" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
        <Col xs={24} md={24} lg={12} xl={8}>
          <Form.Item name="nic" label="NIC" rules={[{ required: requiredMark }]}>
            <BaseInput readOnly={readOnly} />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};
